// extracted by mini-css-extract-plugin
module.exports = {"my_list_nav":"MyListNav_my_list_nav__cXQ7e","my_list_nav_link":"MyListNav_my_list_nav_link__c2CMx"};